<div #toolbar class='toolbar-widget' [ngClass]="{'toolbar-is-scrollable':isScrollable(),
	'configuration-toolbar':configurationToolbar(),
	'admissions-toolbar':admissionsToolbar(),
	'vol-coordination-toolbar':volCoordinationToolbar(),
	'vol-recruitment-toolbar':volRecruitmentToolbar(),
	'delivery-toolbar':deliveryToolbar(),
	'alumni-toolbar':alumniToolbar(),
	'development-toolbar':developementToolbar(),
	'experience-toolbar':experienceToolbar()}">

	<div class='toolbar-content'>
		<ng-content></ng-content>
	</div>

	@if(iconAndTitle(); as iconAndTitle){
	<div class='toolbar-icon'>
		<i class='fa-fw fa-regular {{iconAndTitle.icon}}' [title]='iconAndTitle.title'></i>
	</div>
	}

</div>